//
//
//
//
//
//
//
//

export default {
  props: ['promotion'],
  computed: {
    height() {
      let outcome = _.clone(this.outcome)
      if(_.get(this.selectionsLive, outcome.id)) {
        outcome.odds = _.get(this.selectionsLive, outcome.id+'.odds')
        outcome.display_odds = _.get(this.selectionsLive, outcome.id+'.display_odds')
      }
      return outcome;
    },
  },
  methods: {
    resizeImage(image) {
      return image
        try {
          let paths = new URL(image)
          return paths.origin + '/cdn-cgi/image/q=95,w=410,h=180,f=webp' + paths.pathname
        } catch(e) {}

        return image;
    },
    openURL(path) {
      this.$router.push(this.localePath({ path: path }))
    },
    goBack() {
      this.$router.back()
    }
  }
}
